const STORAGE_PREFIX = "neo:notification-sounds:";

type PreferenceStorage = Pick<Storage, "getItem" | "setItem">;

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}${userId}`;
}

/** Default-on, user-and-browser-local preference. Tenant id is intentionally absent. */
export function readNotificationSoundsEnabled(
  userId: string,
  storage?: PreferenceStorage,
): boolean {
  try {
    return (storage ?? window.localStorage).getItem(storageKey(userId)) !== "off";
  } catch {
    return true;
  }
}

export function writeNotificationSoundsEnabled(
  userId: string,
  enabled: boolean,
  storage?: PreferenceStorage,
): void {
  try {
    (storage ?? window.localStorage).setItem(storageKey(userId), enabled ? "on" : "off");
  } catch {
    // Storage denial must not break the account screen or notification toasts. The in-memory
    // preference still applies for this session; the next load safely returns to default-on.
  }
}
